import { Browserbase, ObjectStore } from 'browserbase';
import { Sprint } from './sprints';
import { dehydrateDeltas, hydrateDeltas } from './hydration';
import { getNow } from './datetime';

export const DATA_EXPIRES = 1000 * 60 * 60 * 24;
let db: SprintDatabase;

export interface SprintDatabase extends Browserbase {
  sprints: ObjectStore<Sprint, string>;
}

export async function getDb() {
  return db || ((window as any).db = db = await openDatabase());
}

export async function openDatabase() {
  const db = new Browserbase('sprints') as SprintDatabase;

  db.version(1, {
    sprints: 'id, start, end',
  });

  await db.open();

  await db.sprints.where('end').endsBefore(getNow() - DATA_EXPIRES).deleteAll();

  // Convert Deltas to { ops: [] } objects
  db.sprints.store = dehydrateDeltas;

  // Convert { ops: [] } objects to Deltas
  db.sprints.revive = hydrateDeltas;

  return db;
}